import * as Rox from "rox-browser";

export const document_center = {
  reports__delivery_ticket: new Rox.Flag(),
  good_receipts_v2: new Rox.Flag(),
};
